import React from 'react';
import StockHighLowTable from './StockHighLowTable';

const StockHighLowHighs = ({ data }) => {
    // Get the date from the first record if data exists
    const dataDate = data && data.length > 0 && data[0].date
        ? new Date(data[0].date).toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        })
        : '';

    const infoText = `The 52-Week Highs list shows stocks that have reached their highest price point in the past 52 weeks during the trading session.${dataDate ? ` (${dataDate})` : ''}`;

    return (
        <StockHighLowTable
            type="highs"
            titleTop="52-Week Highs:"
            title=""
            info={infoText}
            data={data}
        />
    );
};

export default StockHighLowHighs;